<i18n locale="en" lang="json">
{
  "intro": "Our Service & Planning department can help you further.\n\nFor the correct contact details, please refer to"
}
</i18n>
<i18n locale="nl" lang="json">
{
  "intro": "Onze afdeling Service & Planning helpt je graag verder.\n\nVoor de juiste contactgegevens verwijzen we je graag naar"
}
</i18n>

<template>
  <markdown
    :content="`${t('intro')} [Contact - ZekerArbo](https://www.zekerarbo.nl/contact/){target=${dq}zekerarbo_contact${dq}}.`"
  />
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

const dq = '"';

const { t } = useI18n();
</script>
